import $ from "jquery";
window.jQuery = $;
if ($(".filter-wrap").length) {
  const wrappers = document.querySelectorAll(".filter-wrap");

  wrappers.forEach((wrapper) => {
    wrapper.addEventListener("mouseenter", function (e) {
      wrapper.classList.add("hovering");
      e.stopPropagation();
    });

    wrapper.addEventListener("touchstart", function (e) {
      wrapper.classList.add("hovering");
      e.stopPropagation();
    });

    wrapper.addEventListener("mouseleave", function () {
      wrapper.classList.remove("hovering");
    });

    $("body").on("touchstart", function () {
      wrapper.classList.remove("hovering");
    });

    const links = wrapper.querySelectorAll("ul li");

    links.forEach(function (link) {
      link.addEventListener("click", function () {
        wrapper.classList.remove("hovering");
      });
    });
  });
}
